import React from "react";
import useLabTaskStatus from "./useLabTaskStatus";
import { NoDataOverdueIcon } from "@/components/Icons";

const LabTaskStatus: React.FC = () => {
  const { labTasks, isLoading, error } = useLabTaskStatus();

  if (isLoading) {
    return (
      <div className="w-full max-w-full mx-auto">
        <div className="bg-white rounded-lg shadow-md p-5 border border-gray-200">
          <h2 className="text-lg font-medium text-gray-800 mb-5">
            Lab Task Status
          </h2>
          <div className="flex items-center justify-center py-8">
            <div className="text-gray-500">Loading...</div>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="w-full max-w-full mx-auto">
        <div className="bg-white rounded-lg shadow-md p-5 border border-gray-200">
          <h2 className="text-lg font-medium text-gray-800 mb-5">
            Lab Task Status
          </h2>
          <div className="flex items-center justify-center py-8 text-red-500">
            Failed to load data.
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full max-w-full mx-auto">
      <div className="bg-white rounded-lg shadow-md p-5 border border-gray-200">
        <h2 className="text-lg font-medium text-gray-800 mb-5">
          Lab Task Status
        </h2>

        <div className="h-96 flex flex-col">
          {labTasks.length === 0 ? (
            <div className="flex-1 flex flex-col items-center justify-center py-12">
              <NoDataOverdueIcon className="w-24 h-24 mb-4 text-gray-300" />
              <h3 className="text-lg font-medium text-gray-500 mb-2">
                No Task Status
              </h3>
              <p className="text-sm text-gray-400 text-center max-w-xs">
                All tasks are up to date.
              </p>
            </div>
          ) : (
            <div className="flex-1 overflow-y-auto">
              <table className="w-full border-collapse text-sm">
                <thead className="bg-[#FFF5E9] sticky top-0 z-10">
                  <tr>
                    <th className="px-4 py-3 font-semibold text-gray-800 text-left border-b-2 border-gray-200">
                      School Name
                    </th>
                    <th className="px-4 py-3 font-semibold text-gray-800 text-center border-b-2 border-gray-200">
                      Total Tasks
                    </th>
                    <th className="px-4 py-3 font-semibold text-gray-800 text-center border-b-2 border-gray-200">
                      Open Tasks
                    </th>
                    <th className="px-4 py-3 font-semibold text-gray-800 text-center border-b-2 border-gray-200">
                      Closed Tasks
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {labTasks.map((task, index) => (
                    <tr
                      key={task._id}
                      className={`border-b border-gray-100 hover:bg-gray-50 ${
                        index % 2 === 0 ? "bg-white" : "bg-gray-50"
                      }`}
                    >
                      <td className="px-4 py-3 text-orange-500 font-medium text-left">
                        {task.schoolName}
                      </td>
                      <td className="px-4 py-3 text-gray-600 text-center">
                        {task.totalTasks}
                      </td>
                      <td className="px-4 py-3 text-gray-600 text-center">
                        {task.openTasks}
                      </td>
                      <td className="px-4 py-3 text-gray-600 text-center">
                        {task.closedTasks}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default LabTaskStatus;
